import requests from "./httpService";

const TollServices = {
  createToll: async (body) => {
    return requests.post("/toll/", body);
  },
  getAllTolls: async (body) => {
    return requests.get("/toll/", body);
  },
  getTollById: async (id, body) => {
    return requests.get(`/toll/${id}`, body);
  },
  updateToll: async (id, body) => {
    return requests.put(`/toll/${id}`, body);
  },
  updateTollStatus: async (id, body) => {
    return requests.put(`/toll/status/${id}`, body);
  },
  deleteToll: async (id) => {
    return requests.delete(`/toll/${id}`);
  }
};

export default TollServices;
